const RegisterPage = {
  seo: {
    title: 'Register',
  },

  title: 'Welcome!',
  subtitle: 'Enter your email and password to create your account.',
};

export default RegisterPage;
